import React, { useState, useContext } from 'react';
import { AuthContext } from '../context/AuthContext';  // Assuming AuthContext provides user and token
import ApiStatusOverview from '../components/ApiStatusOverview';  // Make sure this import is correct
import CalendarStatus from '../components/CalendarStatus';  // New component for calendar status
import UserManagement from '../components/UserManagement';
import GamesDataBrowser from '../components/admin/GamesDataBrowser';
import VenuesDataBrowser from '../components/admin/VenuesDataBrowser';
import RankingsDataBrowser from '../components/admin/RankingsDataBrowser';
import LinesDataBrowser from '../components/admin/LinesDataBrowser';
import WatchDataPanel from '../components/admin/WatchDataPanel';
import AdminLockManager from '../components/admin/AdminLockManager';
import AdminManualLockCreator from '../components/admin/AdminManualLockCreator';
import AdminSeasonOverride from '../components/admin/AdminSeasonOverride';
import LeagueManagementPanel from '../components/admin/LeagueManagementPanel';
import DiscordChannelManager from '../components/admin/DiscordChannelManager';
import DramaAnalysis from '../components/admin/DramaAnalysis';
import LLMAdminPanel from '../components/admin/LLMAdminPanel';
import PlayoffManagementPanel from '../components/admin/PlayoffManagementPanel';
import PaymentCollectionPanel from '../components/admin/PaymentCollectionPanel';

import styles from '../styles/AdminDashboard.module.css';
import VersionFooter from '../components/VersionFooter';

function AdminDashboard() {
  const { user } = useContext(AuthContext);
  const [activeTab, setActiveTab] = useState('users');
  const [error] = useState('');

  if (!user || user.role !== 'admin') {
    return <div className={styles.errorMessage}>You do not have permission to access this page.</div>;
  }

  const renderComponent = () => {
    switch (activeTab) {
      case 'users':
        return <UserManagement />;
      case 'apiStatus':
        return <ApiStatusOverview />;  // Make sure this line is correct
      case 'locks':
        return <AdminLockManager />;
      case 'createLock':
        return <AdminManualLockCreator />;
      case 'games':
        return <GamesDataBrowser />;
      case 'venues':
        return <VenuesDataBrowser />;
      case 'lines':
        return <LinesDataBrowser />;
      case 'rankings':
        return <RankingsDataBrowser />;
      case 'calendar':
        return <CalendarStatus />;
      case 'watchData':
        return <WatchDataPanel />;
      case 'seasonOverride':
        return <AdminSeasonOverride />;
      case 'leagueManagement':
        return <LeagueManagementPanel />;
      case 'discord':
        return <DiscordChannelManager />;
      case 'drama':
        return <DramaAnalysis />;
      case 'llm':
        return <LLMAdminPanel />;
      case 'playoff':
        return <PlayoffManagementPanel />;
      case 'paymentCollection':
        return <PaymentCollectionPanel />;

      default:
        return <div>Select a tab</div>;
    }
  };

  return (
    <div className={styles.dashboard}>
      <div className={styles.sidebar}>
        <h2 className={styles.dashboardTitle}>Admin Dashboard</h2>
        <button className={`${styles.navButton} ${activeTab === 'users' ? styles.active : ''}`} onClick={() => setActiveTab('users')}>User Management</button>
        <button className={`${styles.navButton} ${activeTab === 'apiStatus' ? styles.active : ''}`} onClick={() => setActiveTab('apiStatus')}>API Status Overview</button>
        <button className={`${styles.navButton} ${activeTab === 'locks' ? styles.active : ''}`} onClick={() => setActiveTab('locks')}>Locks</button>
        <button className={`${styles.navButton} ${activeTab === 'createLock' ? styles.active : ''}`} onClick={() => setActiveTab('createLock')}>Create Manual Lock</button>
        <button className={`${styles.navButton} ${activeTab === 'games' ? styles.active : ''}`} onClick={() => setActiveTab('games')}>Games Data</button>
        <button className={`${styles.navButton} ${activeTab === 'venues' ? styles.active : ''}`} onClick={() => setActiveTab('venues')}>Venues Data</button>
        <button className={`${styles.navButton} ${activeTab === 'lines' ? styles.active : ''}`} onClick={() => setActiveTab('lines')}>Lines Data</button>
        <button className={`${styles.navButton} ${activeTab === 'rankings' ? styles.active : ''}`} onClick={() => setActiveTab('rankings')}>Rankings Data</button>
        <button className={`${styles.navButton} ${activeTab === 'calendar' ? styles.active : ''}`} onClick={() => setActiveTab('calendar')}>Calendar Status</button>
        <button className={`${styles.navButton} ${activeTab === 'watchData' ? styles.active : ''}`} onClick={() => setActiveTab('watchData')}>Watch Data</button>
        <button className={`${styles.navButton} ${activeTab === 'seasonOverride' ? styles.active : ''}`} onClick={() => setActiveTab('seasonOverride')}>Season Management</button>
        <button className={`${styles.navButton} ${activeTab === 'leagueManagement' ? styles.active : ''}`} onClick={() => setActiveTab('leagueManagement')}>League Management</button>
        <button className={`${styles.navButton} ${activeTab === 'discord' ? styles.active : ''}`} onClick={() => setActiveTab('discord')}>Discord Channels</button>
        <button className={`${styles.navButton} ${activeTab === 'drama' ? styles.active : ''}`} onClick={() => setActiveTab('drama')}>Drama Analysis</button>
        <button className={`${styles.navButton} ${activeTab === 'llm' ? styles.active : ''}`} onClick={() => setActiveTab('llm')}>🤖 LLM Admin</button>
        <button className={`${styles.navButton} ${activeTab === 'playoff' ? styles.active : ''}`} onClick={() => setActiveTab('playoff')}>🏆 League Playoff</button>
        <button className={`${styles.navButton} ${activeTab === 'paymentCollection' ? styles.active : ''}`} onClick={() => setActiveTab('paymentCollection')}>💰 Payment Collection</button>

      </div>
      <div className={styles.content}>
        {error && <p className={styles.errorMessage}>{error}</p>}
        {renderComponent()}
        <VersionFooter />
      </div>
    </div>
  );
}

export default AdminDashboard;
